var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"partner2-artists\"><div id=\"artists-list\"><div class=\"loading-spinner\"></div></div><div id=\"artists-details\"></div></div>");;return buf.join("");
};
module.exports = template;